module.exports = __webpack_public_path__ + "img/image1.77ed9136.png";